export default "__VITE_ASSET__VgW56hny__"